import { createUseStyles } from 'react-jss';

const styles = {
  infoWrapper: {
    display: 'flex',
    marginBottom: '5rem',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
